// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3bdD0","paymentContainer":"PaymentPage_paymentContainer__28kZv"};